import { generateUrlParams } from "../../utils/generateUrlParams";
const baseUrl = "DirectEntryApplication";

export const directEntryLoadApplicationFormUrl = (regNumber) =>
	`${baseUrl}/load-direct-entry-application-form?regNumber=${regNumber}`;

export const postDirectEntryPersonalDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-direct-entry-application-form`;

export const directEntryProgrammeDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-direct-entry-programme?`;
export const directEntryEducationHistoryFormUrl = () =>
	`${baseUrl}/add-or-update-direct-entry-education-history`;
export const directEntryPreviousResultFormUrl = () =>
	`${baseUrl}/add-or-update-direct-entry-previous-result`;

export const directEntryOLevelDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-direct-entry-application-olevel-details?`;

export const directEntryUploadCertificateUrl = () =>
	`${baseUrl}/add-or-update-direct-entry-application-certificates`;

export const previewDirectEntryUrl = (jambRegNumber) =>
	`${baseUrl}/application/${jambRegNumber}`;
export const getDirectEntryListUrl = (filter) =>
	`${baseUrl}/direct-entry-list?${generateUrlParams(filter)}`;
export const uploadDirectEntryListUrl = () =>
	`${baseUrl}/upload-direct-entry-list`;
export const downloadDirectEntryListTemplateUrl = () =>
	`${baseUrl}/download-direct-entry-sample-sheet`;
